import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useSWR from "swr";
import { OneBtnModal } from "components/common/modal";
import { InquiryInfoTable, AnswerTable } from "components/inquiry/detail";
import { PrimaryBtn } from "components/common/button";
import { putInquiry } from "service/api/inquiry";
import type { IInquiryList } from "service/interface/help";
import routerConstant from "service/constant/routerConstant";
import responseCodeConstant from "service/constant/responseCodeConstant";

export function InquiryDetailPage() {
  const params = useParams();
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState<IInquiryList>(
    {} as IInquiryList,
  );
  const [isSuccessModalVisible, setIsSuccessmodalVisible] =
    useState<boolean>(false);
  const { data } = useSWR(`/admin/manage/inquiry/${params.id}`);

  useEffect(() => {
    if (data) {
      setDetailData(data.data);
    }
  }, [data]);

  const handleAnswerBtn = async () => {
    const answerRes = await putInquiry({
      inquiryId: params.id,
      answer: detailData.answer,
    });
    if (answerRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSuccessmodalVisible(true);
    }
  };

  const handleSuccessModalBtn = () => {
    navigate(routerConstant.INQUIRY.list);
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSuccessModalVisible}
        setIsVisible={setIsSuccessmodalVisible}
        title="답변 완료"
        subTitle="답변이 완료되었습니다"
        btnClick={handleSuccessModalBtn}
        btnLabel="확인"
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
              문의 내역
            </p>
          </div>
          <div className="mt-[32px] flex flex-col rounded-[12px] bg-white p-[48px_40px_64px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <InquiryInfoTable data={detailData} />
            <AnswerTable data={detailData} setData={setDetailData} />
            <div className="mt-[24px] flex justify-end">
              <PrimaryBtn
                label="답변하기"
                isDisabled={!detailData.answer}
                onClick={handleAnswerBtn}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
